import './Info.css'
import { useTranslation } from 'react-i18next'

import { Header } from '../../components/Header/Header'
import { ReactComponent as Download } from '../../icon/download.svg'

export default function Info() {
	const { t } = useTranslation()

	const fileData = [
		{
			title: 'Описание функциональных характеристик Сервиса Теннисный Турнир',
			edit_date: '27.09.2023',
			url: 'Description_of_functional_characteristics_of_web_service_Tentur.pdf'
		},
		{
			title: 'Лицензионный договор на использование Сервиса Теннисный Турнир',
			edit_date: '27.09.2023',
			url: 'license_agreement_tentur.pdf'
		},
		{
			title: 'Инструкция по эксплуатации Сервиса Теннисный Турнир',
			edit_date: '27.09.2023',
			url: 'Instructions_for_operating_web_service_Tentur.pdf'
		},
		{
			title: 'Политика обработки персональных данных',
			edit_date: '27.09.2023',
			url: 'Personal data_processing_policy_SL_Cosmos.pdf'
		},
		{
			title: 'Положение о конфиденциальности',
			edit_date: '27.09.2023',
			url: 'Privacy_statement_for_web_sites_SL_Space.pdf'
		},
		{
			title: 'Информация по установке программного обеспечения',
			edit_date: '27.09.2023',
			url: 'Installing_the_software.pdf'
		}
	]

	const handleDownload = id => {
		window.open(fileData[id]?.url , '_blank')
	}

	return (
		<>
			<Header
				backButton={true}
				title={t('Info')}
				info={false}
			/>

			<div className="info-container">

				{
					fileData?.map((data, id) => {
						return	<div className="info-block" key={id}>
							<h1 className="info-block__title">
								{ data?.title }
							</h1>

							<p className="info-block__edit">
								Редактировано: { data?.edit_date }
							</p>
	
							<button className="info-block__button" onClick={() => handleDownload(id)}>
								<Download className="download-icon" />
							</button>
						</div>
					})
				}
				{/* <div className="info-block">
					<h1 className="info-block__title">
						Описание функциональных характеристик Сервиса Теннисный Турнир
					</h1>

					<p className="info-block__edit">
						Редактировано: 27.09.2023
					</p>

					<button className="info-block__button" onClick={() => handleDownload(0)}>
						<Download className="download-icon" />
					</button>
				</div> */}

				{/* <div className="info-block">
					<h1 className="info-block__title">
						Лицензионный договор на использование Сервиса Теннисный Турнир
					</h1>

					<p className="info-block__edit">
						Редактировано: 27.09.2023
					</p>

					<button className="info-block__button" onClick={() => handleDownload(1)}>
						<Download className="download-icon" />
					</button>
				</div>

				<div className="info-block">
					<h1 className="info-block__title">
						Инструкция по эксплуатации Сервиса Теннисный Турнир
					</h1>

					<p className="info-block__edit">
						Редактировано: 27.09.2023
					</p>

					<button className="info-block__button" onClick={() => handleDownload(2)}>
						<Download className="download-icon" />
					</button>
				</div>

				<div className="info-block">
					<h1 className="info-block__title">
						Политика обработки персональных данных
					</h1>

					<p className="info-block__edit">
						Редактировано: 27.09.2023
					</p>

					<button className="info-block__button" onClick={() => handleDownload(3)}>
						<Download className="download-icon" />
					</button>
				</div>

				<div className="info-block">
					<h1 className="info-block__title">
						Положение о конфиденциальности
					</h1>

					<p className="info-block__edit">
						Редактировано: 27.09.2023
					</p>

					<button className="info-block__button" onClick={() => handleDownload(4)}>
						<Download className="download-icon" />
					</button>
				</div> */}
			</div>
		</>
	)
}